import React from 'react';
import { Table as AntdTable, TableProps as AntdTableProps, ConfigProvider } from 'antd';
import { useTheme } from '../../theme/ThemeContext';
import type { TableRef } from 'antd/es/table';

export interface TableProps extends AntdTableProps<any> {
    'data-test'?: string;
}

const Table = React.forwardRef<TableRef, TableProps>((props, ref) => {
    const theme = useTheme();
    return (
        <ConfigProvider theme={theme}>
            <AntdTable {...props} ref={ref} data-asper-table data-test={props['data-test']} />
        </ConfigProvider>
    );
});

export default Table;
